<ng-container *transloco="let t">
  <h3 class="text-center py-3">Filtrer</h3>
  <div class="row mb-3 gx-0">
    <div class="col-12 filter-container px-3">

      <div class="alert alert-info" role="alert">
        <lucide-icon [img]="icons.info"></lucide-icon>
        Bientôt de nouveaux filtres: type d'activité, etc.
      </div>

      <p class="d-none d-lg-block text-center">
        <button type="button" class="btn btn-light" (click)="resetFilters()">Réinitialiser</button>
      </p>

      <form [formGroup]="filterForm">

        <h4 class="text-primary mt-2">
          <lucide-icon [img]="icons.activity"></lucide-icon> Activité
        </h4>
        <p class="fw-bold my-1">Type</p>
        <div>
          <div class="btn-group d-flex days" role="group" aria-label="Basic outlined example">
            <button
              type="button"
              [class.active]="selectedActivityTypes().includes(activityTypes.Activity)"
              (click)="toggleActivityType(activityTypes.Activity)"
              class="btn btn-outline-secondary">
              {{ t('guest.search.ActivityType.Activity') }}
              <app-activity-type-icon [type]="activityTypes.Activity"></app-activity-type-icon>
            </button>
            <button
              type="button"
              [class.active]="selectedActivityTypes().includes(activityTypes.Event)"
              (click)="toggleActivityType(activityTypes.Event)"
              class="btn btn-outline-secondary">
              {{ t('guest.search.ActivityType.Event') }}
              <app-activity-type-icon [type]="activityTypes.Event"></app-activity-type-icon>
            </button>
          </div>
          <p>
            @if (selectedActivityTypes()) {
              {{ selectedActivityTypesString() }}
            } @else {
              &nbsp;
            }
          </p>
        </div>

        <h4 class="text-primary mt-2">
          <lucide-icon [img]="icons.schedule"></lucide-icon>
          Horaire
        </h4>
        <p class="fw-bold my-1">Jours</p>
        <div>
          <div class="btn-group d-flex days" role="group" aria-label="Basic outlined example">
            @for (day of weekDays; track day) {
              <button
                type="button"
                [class.active]="selectedDays().includes(day)"
                (click)="toggleDay(day)"
                class="btn btn-outline-secondary">
                {{ t('enum.WeekDay.abbrev.' + day) }}
              </button>
            }
          </div>
        </div>
        <p class="fw-bold my-1">Heure</p>
        <div>
          <div class="btn-group d-flex" role="group" aria-label="Basic outlined example">
            @for (dayTime of dayTimes; track dayTime) {
              <button
                type="button"
                [class.active]="selectedTimes().includes(dayTime)"
                (click)="toggleDayTime(dayTime)"
                class="btn btn-outline-secondary">
                <lucide-icon [img]="icons[dayTime]"></lucide-icon>
              </button>
            }
          </div>
        </div>
        <p>
          @if (selectedTimes().length > 0) {
            Début:
            @for (dayTime of selectedTimes(); track dayTime; let isLast = $last) {
              {{ t('enum.DayTime.' + dayTime) }}
              ({{ dayTimeMins[dayTime] }}h-{{ dayTimeMaxs[dayTime] }}h)@if (!isLast){{{', '}}}
            }
          } @else {
            &nbsp;
          }
        </p>

        <div>
          <div class="btn-group d-flex" role="group" aria-label="Basic outlined example">
            <button
              type="button"
              [class.active]="selectedIsRecurring().includes(1)"
              (click)="toggleIsRecurring(1)"
              class="btn btn-outline-secondary">
              Régulière
              <lucide-icon [img]="icons.repeat1"></lucide-icon>
            </button>
            <button
              type="button"
              [class.active]="selectedIsRecurring().includes(0)"
              (click)="toggleIsRecurring(0)"
              class="btn btn-outline-secondary">
              Ponctuelle
              <lucide-icon [img]="icons.repeat0"></lucide-icon>
            </button>
          </div>
        </div>

        <h4 class="text-primary mt-2">
          <lucide-icon [img]="icons.audience"></lucide-icon> Audience
        </h4>
        <p class="fw-bold my-1">Âge</p>
        <app-integer-range
          [control]="filterForm.controls.ageRange"
          [showValueLabel]="true">
        </app-integer-range>
        <p class="fw-bold my-1">Niveau</p>
        <div>
          <div class="btn-group d-flex days" role="group" aria-label="Basic outlined example">
            @for (level of levels; track level) {
              <button
                type="button"
                [class.active]="selectedLevels().includes(level)"
                (click)="toggleLevel(level)"
                class="btn btn-outline-secondary">
                <app-schedule-level-icon [level]="level"></app-schedule-level-icon>
              </button>
            }
          </div>
          <p>
            @if (selectedLevelsString()) {
              Activités {{ selectedLevelsString() }}
            } @else {
              &nbsp;
            }
          </p>
        </div>

        <p class="fw-bold my-1">Genre</p>
        <div>
          <div class="btn-group d-flex days" role="group" aria-label="Basic outlined example">
            @for (gender of genders; track gender) {
              <button
                type="button"
                [class.active]="selectedGenders().includes(gender)"
                (click)="toggleGender(gender)"
                class="btn btn-outline-secondary">
                <app-person-gender-icon [gender]="gender"></app-person-gender-icon>
              </button>
            }
          </div>
          <p>
            @if (selectedGendersString()) {
              Activités {{ selectedGendersString() }}
            } @else {
              &nbsp;
            }
          </p>
        </div>

      </form>
    </div>
  </div>

</ng-container>

